var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBezlicznik(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 622,
    height: 95,
    viewBox: "0 0 622 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M179.194 62.5156C179.194 63.6823 178.987 64.934 178.574 66.2708C178.185 67.6076 177.529 68.8472 176.605 69.9896C175.706 71.1319 174.527 72.092 173.069 72.8698C171.61 73.6233 169.824 74 167.709 74H131.725C131.044 74 130.412 73.8785 129.829 73.6354C129.246 73.3924 128.735 73.0642 128.298 72.651C127.885 72.2135 127.557 71.7031 127.313 71.1198C127.07 70.5365 126.949 69.9045 126.949 69.2239V26.4947C126.949 25.8384 127.07 25.2186 127.313 24.6353C127.557 24.052 127.885 23.5415 128.298 23.104C128.735 22.6665 129.246 22.3263 129.829 22.0832C130.412 21.8402 131.044 21.7186 131.725 21.7186H163.444C164.61 21.7186 165.862 21.9252 167.199 22.3384C168.536 22.7516 169.775 23.42 170.918 24.3436C172.084 25.2429 173.044 26.4218 173.798 27.8801C174.576 29.3384 174.965 31.1249 174.965 33.2395V35.026C174.965 36.703 174.685 38.5138 174.126 40.4583C173.567 42.3784 172.668 44.2013 171.428 45.927C172.498 46.5833 173.494 47.3732 174.418 48.2968C175.366 49.2204 176.192 50.2899 176.897 51.5052C177.602 52.7204 178.161 54.0937 178.574 55.625C178.987 57.1562 179.194 58.8455 179.194 60.6927V62.5156ZM169.715 60.6927C169.715 59.4531 169.52 58.3472 169.131 57.375C168.742 56.3784 168.196 55.5277 167.491 54.8229C166.786 54.118 165.935 53.5833 164.939 53.2187C163.942 52.8298 162.824 52.6354 161.584 52.6354H140.22V43.0833H157.319C158.558 43.0833 159.676 42.901 160.673 42.5364C161.669 42.1475 162.52 41.6006 163.225 40.8958C163.93 40.1909 164.465 39.3524 164.829 38.3801C165.218 37.3836 165.413 36.2655 165.413 35.026V33.2395C165.413 31.8784 164.756 31.1978 163.444 31.1978H136.428V64.5208H167.709C167.88 64.5208 168.086 64.5087 168.329 64.4844C168.572 64.46 168.791 64.3871 168.985 64.2656C169.18 64.1441 169.35 63.9375 169.496 63.6458C169.642 63.3541 169.715 62.9531 169.715 62.4427V60.6927ZM230.454 52.6354H200.522V43.0833H230.454V52.6354ZM234.72 74H200.522C199.209 74 197.775 73.7691 196.22 73.3073C194.664 72.8455 193.218 72.092 191.881 71.0469C190.569 69.9774 189.463 68.6042 188.564 66.9271C187.689 65.2257 187.251 63.1475 187.251 60.6927V26.4947C187.251 25.8384 187.373 25.2186 187.616 24.6353C187.859 24.052 188.187 23.5415 188.6 23.104C189.038 22.6665 189.548 22.3263 190.131 22.0832C190.715 21.8402 191.347 21.7186 192.027 21.7186H234.72V31.1978H196.73V60.6927C196.73 61.9323 197.058 62.8802 197.715 63.5364C198.371 64.1927 199.331 64.5208 200.595 64.5208H234.72V74ZM288.642 24.5624C289.007 25.4131 289.116 26.3124 288.97 27.2603C288.824 28.1839 288.435 28.9739 287.803 29.6301L256.522 64.5208H288.569V74H245.84C244.916 74 244.053 73.7448 243.251 73.2344C242.473 72.6996 241.89 72.0069 241.501 71.1562C241.088 70.3055 240.954 69.4184 241.1 68.4948C241.27 67.5712 241.659 66.7691 242.267 66.0885L273.621 31.1978H241.501V21.7186H284.303C285.227 21.7186 286.078 21.986 286.856 22.5207C287.658 23.0311 288.253 23.7117 288.642 24.5624ZM345.225 74H301.986C301.305 74 300.673 73.8785 300.09 73.6354C299.507 73.3924 298.996 73.0642 298.559 72.651C298.145 72.2135 297.817 71.7031 297.574 71.1198C297.331 70.5365 297.21 69.9045 297.21 69.2239V21.7186H306.689V64.5208H345.225V74ZM361.741 74H352.262V21.7186H361.741V74ZM419.637 74H385.439C384.564 74 383.616 73.9028 382.595 73.7083C381.599 73.4896 380.602 73.1615 379.606 72.724C378.634 72.2865 377.698 71.7274 376.798 71.0469C375.899 70.342 375.097 69.5035 374.392 68.5312C373.712 67.5347 373.165 66.3923 372.752 65.1041C372.338 63.7916 372.132 62.3212 372.132 60.6927V35.026C372.132 34.1509 372.229 33.2152 372.423 32.2187C372.642 31.1978 372.97 30.2013 373.408 29.2291C373.845 28.2325 374.416 27.2846 375.121 26.3853C375.826 25.486 376.665 24.6961 377.637 24.0155C378.634 23.3106 379.776 22.7516 381.064 22.3384C382.352 21.9252 383.811 21.7186 385.439 21.7186H419.637V31.1978H385.439C384.199 31.1978 383.252 31.5259 382.595 32.1822C381.939 32.8384 381.611 33.8107 381.611 35.0989V60.6927C381.611 61.908 381.939 62.8559 382.595 63.5364C383.276 64.1927 384.224 64.5208 385.439 64.5208H419.637V74ZM473.34 24.5624C473.705 25.4131 473.814 26.3124 473.668 27.2603C473.523 28.1839 473.134 28.9739 472.502 29.6301L441.22 64.5208H473.267V74H430.538C429.615 74 428.752 73.7448 427.95 73.2344C427.172 72.6996 426.589 72.0069 426.2 71.1562C425.786 70.3055 425.653 69.4184 425.799 68.4948C425.969 67.5712 426.358 66.7691 426.965 66.0885L458.319 31.1978H426.2V21.7186H469.002C469.925 21.7186 470.776 21.986 471.554 22.5207C472.356 23.0311 472.951 23.7117 473.34 24.5624ZM534.153 69.9531C534.153 70.6337 534.019 71.2656 533.752 71.849C533.509 72.4323 533.169 72.9427 532.731 73.3802C532.318 73.7934 531.82 74.1215 531.236 74.3646C530.653 74.6076 530.033 74.7292 529.377 74.7292C528.794 74.7292 528.198 74.6198 527.59 74.401C527.007 74.1823 526.485 73.8299 526.023 73.3437L491.387 37.177V74H481.908V25.7655C481.908 24.7933 482.175 23.9183 482.71 23.1405C483.269 22.3384 483.974 21.7429 484.825 21.354C485.724 20.9895 486.648 20.9044 487.596 21.0988C488.543 21.269 489.358 21.7065 490.038 22.4113L524.674 58.5416V21.7186H534.153V69.9531ZM554.752 74H545.273V21.7186H554.752V74ZM620.632 74H607.179L585.851 52.6354H579.179V43.0833H585.851L607.179 21.7186H620.632L593.762 47.8593L620.632 74ZM575.387 74H565.908V21.7186H575.387V74Z",
    fill: "#2E4C99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.637 5.82031V91.2402",
    stroke: "#2E4C99",
    strokeWidth: 4.21039,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2541 57.2918C44.3665 61.1794 36.8646 61.7585 33.3457 61.6469C16.7391 61.6469 4.43115 48.6685 4.43115 32.062C4.43115 15.4555 17.8935 1.99316 34.4999 1.99316C51.1068 1.99316 64.5691 15.4555 64.5691 32.062C64.5503 33.7129 64.245 37.5173 63.1726 39.5281",
    stroke: "#2E4C99",
    strokeWidth: 2.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 67.9214H29.1193",
    stroke: "#2E4C99",
    strokeWidth: 2.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 80.2466H48.2592",
    stroke: "#2E4C99",
    strokeWidth: 2.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3828 85.8932V63.0381",
    stroke: "#2E4C99",
    strokeWidth: 2.59101,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8723 85.8932V63.0381",
    stroke: "#2E4C99",
    strokeWidth: 2.59101,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9463 69.0942V60.2319",
    stroke: "#2E4C99",
    strokeWidth: 2.7
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3889 68.8335V59.9712",
    stroke: "#2E4C99",
    strokeWidth: 2.7
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2161 67.8467H48.5944",
    stroke: "#2E4C99",
    strokeWidth: 2.7
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0239 56.8877H68.7857",
    stroke: "#2E4C99",
    strokeWidth: 2.7
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8901 49.8799H41.4635",
    stroke: "#2E4C99",
    strokeWidth: 2.7,
    strokeLinejoin: "bevel"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8901 44.499H47.4774",
    stroke: "#2E4C99",
    strokeWidth: 2.7,
    strokeLinejoin: "bevel"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M71.634 56.8877H74.4827",
    stroke: "#2E4C99",
    strokeWidth: 2.7
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9956 49.8799H48.1104",
    stroke: "#2E4C99",
    strokeWidth: 2.7,
    strokeLinejoin: "bevel"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4824 40.9637L16.2132 39.228",
    stroke: "#2E4C99",
    strokeWidth: 1.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7598 31.991L14.8741 31.9355",
    stroke: "#2E4C99",
    strokeWidth: 1.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0647 23.0308L15.9878 24.2716",
    stroke: "#2E4C99",
    strokeWidth: 1.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1443 18.2252L17.467 15.1006",
    stroke: "#2E4C99",
    strokeWidth: 1.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9455 13.1818L25.2075 9.45215",
    stroke: "#2E4C99",
    strokeWidth: 1.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2769 11.8051V7.69043",
    stroke: "#2E4C99",
    strokeWidth: 1.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5569 13.502L43.7526 9.56494",
    stroke: "#2E4C99",
    strokeWidth: 1.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5498 17.9878L51.4688 15.0879",
    stroke: "#2E4C99",
    strokeWidth: 1.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1724 28.3838L45.4521 21.104",
    stroke: "#2E4C99",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6267 24.1991L57.3531 22.4541",
    stroke: "#2E4C99",
    strokeWidth: 1.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4604 31.8389L58.5745 31.9085",
    stroke: "#2E4C99",
    strokeWidth: 1.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0698 39.5244H50.1206C49.1026 39.5244 48.2773 40.3497 48.2773 41.3676V84.3951C48.2773 85.413 49.1026 86.2383 50.1206 86.2383H82.0698C83.0878 86.2383 83.9131 85.413 83.9131 84.3951V41.3676C83.9131 40.3497 83.0878 39.5244 82.0698 39.5244Z",
    stroke: "#2E4C99",
    strokeWidth: 2.65701,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6906 45.3071H53.4998V62.2686H78.6906V45.3071Z",
    stroke: "#2E4C99",
    strokeWidth: 2.32063,
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4711 70.748H53.739V79.1636H62.4711V70.748Z",
    stroke: "#2E4C99",
    strokeWidth: 2.1,
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6906 70.6284H69.9585V79.044H78.6906V70.6284Z",
    stroke: "#2E4C99",
    strokeWidth: 2.1,
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8165 36.5862C37.3152 36.5862 39.3408 34.5606 39.3408 32.0619C39.3408 29.5632 37.3152 27.5376 34.8165 27.5376C32.3178 27.5376 30.2922 29.5632 30.2922 32.0619C30.2922 34.5606 32.3178 36.5862 34.8165 36.5862Z",
    stroke: "#2E4C99",
    strokeWidth: 2.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBezlicznik);
export default __webpack_public_path__ + "static/media/logo-bezlicznik.10796686cc96411bea5f99cf1aca668a.svg";
export { ForwardRef as ReactComponent };